import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 offset-lg-1 pt-2 col-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "patients-personal-goals",
  class: "mb-2"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Patient's Personal Goals")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "col-12 offset-lg-1 pt-2 col-lg-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "patients-care-goals",
  class: "mb-2"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Patient's Care Goals")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "col-12 offset-lg-1 pt-2 col-lg-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "barrier-care-goals",
  class: "mb-2"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Barriers to Care/Goals")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "col-12 offset-lg-1 pt-2 col-lg-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "crisis-care-plan",
  class: "mb-2"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Crisis Care Plan")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FormSection, {
      title: "Patient Goals",
      popoverContent: _ctx.popoverContent,
      "full-height": false,
      "application-id": _ctx.application,
      type: "his-section"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_CommentInput, {
            id: "patients-personal-goals",
            result: _ctx.patient.patientGoals.personalGoals,
            onResultUpdatedAppended: _ctx.resultPersonalGoalsAppended,
            onResultUpdated: _ctx.resultPersonalGoals,
            placeholder: "Enter Patient's Personal Goals",
            application: _ctx.application
          }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "application"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_CommentInput, {
            id: "patients-care-goals",
            result: _ctx.patient.patientGoals.careGoals,
            onResultUpdatedAppended: _ctx.resultCareGoalsAppended,
            onResultUpdated: _ctx.resultCareGoals,
            placeholder: "Enter Patient's Care Goals",
            application: _ctx.application
          }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "application"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_CommentInput, {
            id: "barrier-care-goals",
            result: _ctx.patient.patientGoals.barriersToPersonalOrCareGoals,
            onResultUpdatedAppended: _ctx.resultBarriersGoalsAppended,
            onResultUpdated: _ctx.resultBarriersGoals,
            placeholder: "Enter Barriers to Care/Goals",
            application: _ctx.application
          }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "application"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_CommentInput, {
            id: "crisis-care-plan",
            result: _ctx.patient.patientGoals.crisisCarePlan,
            onResultUpdatedAppended: _ctx.resultCrisisCareAppended,
            onResultUpdated: _ctx.resultCrisisCare,
            placeholder: "Enter Crisis Care Plan",
            application: _ctx.application
          }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "application"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["popoverContent", "application-id"])
  ]))
}